export const UserCompanyInvitationFragment = gql`
  fragment UserCompanyInvitationFragment on UserCompanyInvitation {
    acceptedAt
    createdAt
    rejectedAt
    role
    title
    company {
      ...CompanyFragment
    }
    createdByUser {
      ...UserDataFragment
    }
    user {
      ...UserDataFragment
    }
  }
`
